import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const stageCriterionRoute: RouteConfig = {
  path: ':stageId/criterions',
  name: 'stageCriterionList',
  component: () => import(/* webpackChunkName: "StageCriterion" */ '@/views/mainRoute/stage/Criterion.vue'),
  meta: {
    breadcrumb: {
      title: 'Kryteria Etapu'
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('criterion/list', { stageId: tryParseInt(to.params.stageId), rootOnly: true })
      .then(() => next())
      .catch((err: any) => store.dispatch('notifyError', { title: Errors.CRITERION_CANNOT_LIST }));
  }
};
